function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 7.3,
  y1: 14.4,
  x2: 64,
  y2: 14.4
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 25.6,
  x2: 21,
  y2: 25.6
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 7.4,
  y: 20.9,
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  width: 84.1,
  height: 117.6
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 29.5,
  x2: 91,
  y2: 29.5
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 34.6,
  x2: 21,
  y2: 34.6
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 38.5,
  x2: 91,
  y2: 38.5
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 43.6,
  x2: 21,
  y2: 43.6
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 47.5,
  x2: 91,
  y2: 47.5
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 56.5,
  x2: 91,
  y2: 56.5
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 52.6,
  x2: 21,
  y2: 52.6
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 56.5,
  x2: 91,
  y2: 56.5
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 61.6,
  x2: 21,
  y2: 61.6
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 65.5,
  x2: 91,
  y2: 65.5
});

var _ref15 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 70.6,
  x2: 21,
  y2: 70.6
});

var _ref16 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 74.5,
  x2: 91,
  y2: 74.5
});

var _ref17 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 79.6,
  x2: 21,
  y2: 79.6
});

var _ref18 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 83.5,
  x2: 91,
  y2: 83.5
});

var _ref19 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 92.5,
  x2: 91,
  y2: 92.5
});

var _ref20 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 88.6,
  x2: 21,
  y2: 88.6
});

var _ref21 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 29.3,
  y1: 25.6,
  x2: 43.9,
  y2: 25.6
});

var _ref22 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 29.3,
  y1: 34.6,
  x2: 43.9,
  y2: 34.6
});

var _ref23 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 29.3,
  y1: 43.6,
  x2: 43.9,
  y2: 43.6
});

var _ref24 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#0F63F2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 29.3,
  y1: 52.6,
  x2: 43.9,
  y2: 52.6
});

var _ref25 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 29.3,
  y1: 61.6,
  x2: 43.9,
  y2: 61.6
});

var _ref26 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 29.3,
  y1: 70.6,
  x2: 43.9,
  y2: 70.6
});

var _ref27 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 29.3,
  y1: 79.6,
  x2: 43.9,
  y2: 79.6
});

var _ref28 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 48,
  y1: 25.6,
  x2: 50.9,
  y2: 25.6
});

var _ref29 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 48,
  y1: 34.6,
  x2: 50.9,
  y2: 34.6
});

var _ref30 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 48,
  y1: 43.6,
  x2: 50.9,
  y2: 43.6
});

var _ref31 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#0F63F2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 48,
  y1: 52.6,
  x2: 50.9,
  y2: 52.6
});

var _ref32 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 48,
  y1: 61.6,
  x2: 50.9,
  y2: 61.6
});

var _ref33 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 48,
  y1: 70.6,
  x2: 50.9,
  y2: 70.6
});

var _ref34 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 48,
  y1: 79.6,
  x2: 50.9,
  y2: 79.6
});

var _ref35 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 92.5,
  x2: 91,
  y2: 92.5
});

var _ref36 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 101.5,
  x2: 91,
  y2: 101.5
});

var _ref37 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 110.5,
  x2: 91,
  y2: 110.5
});

var _ref38 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 119.5,
  x2: 91,
  y2: 119.5
});

var _ref39 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 7.5,
  y1: 128.5,
  x2: 91,
  y2: 128.5
});

var _ref40 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 25.5,
  y1: 138,
  x2: 25.5,
  y2: 21.5
});

var _ref41 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 59.3,
  y1: 25.6,
  x2: 69,
  y2: 25.6
});

var _ref42 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 59.3,
  y1: 34.6,
  x2: 69,
  y2: 34.6
});

var _ref43 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 59.3,
  y1: 43.6,
  x2: 69,
  y2: 43.6
});

var _ref44 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 59.3,
  y1: 52.6,
  x2: 69,
  y2: 52.6
});

var _ref45 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 59.3,
  y1: 61.6,
  x2: 69,
  y2: 61.6
});

var _ref46 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 59.3,
  y1: 70.6,
  x2: 69,
  y2: 70.6
});

var _ref47 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 73.5,
  y1: 138,
  x2: 73.5,
  y2: 21.5
});

var _ref48 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 55.5,
  y1: 138,
  x2: 55.5,
  y2: 21.5
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 47.5,
  fill: "none",
  stroke: "#0F63F2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  width: 30,
  height: 9
});

var _ref50 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 77.3,
  y1: 25.6,
  x2: 87,
  y2: 25.6
});

var _ref51 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 77.3,
  y1: 34.6,
  x2: 87,
  y2: 34.6
});

var _ref52 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 77.3,
  y1: 43.6,
  x2: 87,
  y2: 43.6
});

var _ref53 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 77.3,
  y1: 52.6,
  x2: 87,
  y2: 52.6
});

var _ref54 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 77.3,
  y1: 61.6,
  x2: 87,
  y2: 61.6
});

var _ref55 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 77.3,
  y1: 70.6,
  x2: 87,
  y2: 70.6
});

var _ref56 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 77.3,
  y1: 79.6,
  x2: 87,
  y2: 79.6
});

var _ref57 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 77.3,
  y1: 88.6,
  x2: 87,
  y2: 88.6
});

var SvgSpreadsheet = function SvgSpreadsheet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 150",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpreadsheet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spreadsheet.71bcd613.svg";
export { ForwardRef as ReactComponent };